
import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Download } from 'lucide-react';
import * as XLSX from 'xlsx';

const DistributionCenterUploadTemplate: React.FC = () => {
  const downloadTemplate = () => {
    const template = [
      {
        'Timestamp': '2024-01-01',
        'Product List': 'Example Product',
        'Location': 'Example Location',
        'Buying Price': 100.00,
        'Product Remark': 'Example remark'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Distribution Center Prices');
    XLSX.writeFile(wb, 'distribution_center_prices_template.xlsx');
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        <Label>Excel File</Label>
        <p className="text-sm text-gray-600">
          Upload an Excel file with columns: Timestamp, Product List, Location, Buying Price, Product Remark
        </p>
      </div>
      <Button
        variant="outline"
        onClick={downloadTemplate}
        className="flex items-center gap-2"
      >
        <Download className="h-4 w-4" />
        Download Template
      </Button>
    </div>
  );
};

export default DistributionCenterUploadTemplate;
